import { IWebAuthData, IWebAuthSessionData } from '../shared/models';
import * as Actions from '../actions/webauth.actions';

export interface State {
  webAuthData: IWebAuthData;
  sessionData: IWebAuthSessionData;
}

export const initialState: State = {
  webAuthData: undefined,
  sessionData: undefined,
};

export function reducer(state = initialState, action: Actions.All): State {
  switch (action.type) {
    case Actions.WEB_AUTH_SAVE: {
      return Object.assign({}, state, {
        webAuthData: {
          ...action.payload.webAuthData,
          timestamp: Date.now(),
        },
      });
    }
    case Actions.WEB_AUTH_UPDATE_DATA: {
      return Object.assign({}, state, {
        webAuthData: Object.assign({}, state.webAuthData, action.payload.data, {
          timestamp: Date.now(),
        }),
      });
    }
    case Actions.WEB_AUTH_UPDATE_SESSION_DATA: {
      return Object.assign({}, state, {
        sessionData: Object.assign({}, state.sessionData, action.payload.data),
      });
    }
    case Actions.WEB_AUTH_CLEAR:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
}
